"use client"

import { useTranslations } from "next-intl"

import { BottomNavTab } from "@/components/marketplace/layout/bottom-nav-tab"
import { useBagCount } from "@/components/marketplace/layout/use-bag-count"
import { NavBagIcon, NavGridIcon, NavHomeIcon, NavUserIcon } from "@/components/ui/icons"
import { usePathname } from "@/i18n/navigation"
import { ROUTES, segmentsAfterRegion } from "@/lib/routes"

interface BottomNavProps {
  bagCount?: number
  onCategoriesPress?: () => void
  categoriesOpen?: boolean
}

export const BottomNav = ({ bagCount: bagCountOverride, onCategoriesPress, categoriesOpen = false }: BottomNavProps) => {
  const t = useTranslations("nav")
  const bagCount = useBagCount(bagCountOverride)
  const pathname = usePathname()
  const segments = segmentsAfterRegion(pathname)
  const first = segments[0]
  const routeActive = (match: boolean) => !categoriesOpen && match

  return (
    <nav aria-label={t("tabBar")} className="nav-pill h-nav grid min-w-0 flex-1 grid-cols-4 gap-100 rounded-full pr-450 pl-425">
      <BottomNavTab href="/" label={t("home")} active={routeActive(segments.length === 0)} outline={<NavHomeIcon />} filled={<NavHomeIcon filled />} />
      <BottomNavTab
        href={onCategoriesPress ? undefined : `/${ROUTES.CATEGORIES}`}
        onPress={onCategoriesPress}
        expanded={onCategoriesPress ? categoriesOpen : undefined}
        label={t("categories")}
        active={categoriesOpen || first === ROUTES.CATEGORIES}
        outline={<NavGridIcon />}
        filled={<NavGridIcon filled />}
      />
      <BottomNavTab
        href={`/${ROUTES.CART}`}
        label={t("bag")}
        active={routeActive(first === ROUTES.CART)}
        outline={<NavBagIcon />}
        filled={<NavBagIcon filled />}
        badge={bagCount}
      />
      <BottomNavTab href={`/${ROUTES.ACCOUNT}`} label={t("account")} active={routeActive(first === ROUTES.ACCOUNT)} outline={<NavUserIcon />} filled={<NavUserIcon filled />} />
    </nav>
  )
}
